'use client';

import { DrawerCollapsible } from './DrawerCollapsible';
import type { DrawerCollapsibleVariant } from './DrawerCollapsible';

export type DrawerCustomSectionProps = {
  title: string;
  children: React.ReactNode;
  onViewAllClick?: () => void;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  variant?: DrawerCollapsibleVariant;
  hideHeaderDivider?: boolean;
  dense?: boolean;
  action?: React.ReactNode;
};

export function DrawerCustomSection({
  title,
  children,
  onViewAllClick,
  defaultOpen = true,
  onOpenChange,
  variant,
  hideHeaderDivider,
  dense,
  action,
}: DrawerCustomSectionProps) {
  return (
    <DrawerCollapsible
      title={title}
      onViewAllClick={onViewAllClick}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      variant={variant}
      hideHeaderDivider={hideHeaderDivider}
      dense={dense}
      action={action}
    >
      {children}
    </DrawerCollapsible>
  );
}
